import React from 'react';
import HowItWorks from '../components/HowItWorks';
import WParkHero from '../components/WParkHero';
import AboutSection from '../components/AboutSection';
import SupportedBy from '../components/SupportedBy';
import WhyWpark from '../components/WhyWPark';
import TechAdvantage from '../components/TechAdvantage';
import WParkUWBSection from '../components/WParkUWBSection';
import WParkUWBUseCasesSection from '../components/WParkUseCasesSection';
import Team from '../components/Team';
import { Helmet } from 'react-helmet';
import wparkFavicon from '../assets/WPARK_logo.png'; // or .ico
import ParkingProblem from '../components/ParkingProblem';
import SpectreButton from '../components/SpectreButton';
import Newsroom from '../components/Newsroom';
import Product from '../components/Product';
import Home from '../components/Home';
import autonomy from '../components/autonomy';
import Autonomy from '../components/autonomy';


const HomePage = () => {
    return (
        <div>
         <Helmet>
                <title>WPark</title>
                <link rel="icon" type="image/png" href={wparkFavicon} />
        </Helmet>
            <Autonomy />
        </div>
    );
};

export default HomePage;



